/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const CheckoutContentSkeleton = (props) => (
    <ContentLoader
        height={"100vh"}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* Main content */}
        <rect x={`calc(20% - 25px)`} y="24" rx="3" ry="3" width="55%" height="600"/>

        {/* Sidebar */}
        <rect x="75%" y="24" rx="3" ry="3" width="25%" height="300"/>

    </ContentLoader>
)
